import { TICKER_ITEMS } from "@/data/content";
import { useT } from "@/i18n/LanguageContext";

export const Ticker = () => {
  const t = useT();
  const row = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div
      data-testid="ticker-section"
      className="relative border-y border-[#E8E7E2] bg-[#F4F2EC]/70 py-5 overflow-hidden"
    >
      <div className="wf-marquee">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-6 px-6 font-heading text-sm uppercase tracking-[0.25em] text-[#8A8F9C] whitespace-nowrap"
          >
            {t(item)}
            <span className="w-1.5 h-1.5 rounded-full bg-[#0A0A0F]/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
